import type { ProfessionalCardRefusalReason } from "./supabase.enum";

// What the WSM can object to depends on what the consultant filed: a creation carries the talent's photo and
// identity document, a card update only names the talent's verified card.
const PROFESSIONAL_CARD_CREATION_REFUSAL_REASONS: readonly ProfessionalCardRefusalReason[] = [
  "non_compliant_photo",
  "incorrect_or_unreadable_document",
  "other",
];

const PROFESSIONAL_CARD_UPDATE_REFUSAL_REASONS: readonly ProfessionalCardRefusalReason[] = ["invalid_card", "other"];

export const getProfessionalCardRefusalReasons = (isCardUpdate: boolean): readonly ProfessionalCardRefusalReason[] =>
  isCardUpdate ? PROFESSIONAL_CARD_UPDATE_REFUSAL_REASONS : PROFESSIONAL_CARD_CREATION_REFUSAL_REASONS;
